/**
 * Utility function to handle profile picture URLs
 * Supports both legacy relative paths and new full URLs
 */
export const getProfilePictureUrl = (profilePictureUrl?: string | null): string => {
  if (!profilePictureUrl) {
    return "";
  }

  // If it's already a full URL (starts with http/https), return as is
  if (profilePictureUrl.startsWith("http://") || profilePictureUrl.startsWith("https://")) {
    return profilePictureUrl;
  }

  // Legacy format: construct URL with base path
  return `http://hr.amniltech.com/Uploads/${profilePictureUrl}`;
};
